<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
};
</script>

<style lang="scss">
@import '@/element/element-variables.scss';
  #nprogress .bar {
    background: $--color-primary !important;
  }
  #nprogress .spinner-icon{
    border-top-color: $--color-primary !important;
    border-left-color: $--color-primary !important;
  }
</style>
